import { render, staticRenderFns } from "./PlanStep.vue?vue&type=template&id=463ab136&"
import script from "./PlanStep.vue?vue&type=script&lang=js&"
export * from "./PlanStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('463ab136')) {
      api.createRecord('463ab136', component.options)
    } else {
      api.reload('463ab136', component.options)
    }
    module.hot.accept("./PlanStep.vue?vue&type=template&id=463ab136&", function () {
      api.rerender('463ab136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/PlanStep.vue"
export default component.exports